import { render, staticRenderFns } from "./WebFormSubmitted.vue?vue&type=template&id=25718b94&scoped=true"
import script from "./WebFormSubmitted.vue?vue&type=script&lang=js"
export * from "./WebFormSubmitted.vue?vue&type=script&lang=js"
import style0 from "./WebFormSubmitted.vue?vue&type=style&index=0&id=25718b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25718b94",
  null
  
)

export default component.exports